import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface FunnelStep {
  name: string;
  count: number;
}

export interface ReviewsFunnel {
  period_start: string | null;
  period_end: string;
  period_label: "since_launch" | "custom";
  meta: {
    lifetime_steps: string[];
  };
  steps: FunnelStep[];
}

export function useReviewsFunnel() {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["reviews", "funnel"],
    queryFn: async () => {
      const res = await fetch("/api/cockpit/reviews/funnel", {
        headers,
      });
      if (!res.ok) throw new Error("Reviews funnel failed");
      return res.json() as Promise<ReviewsFunnel>;
    },
    staleTime: 5 * 60_000,
  });
}
